//el metadato guarda el codigo del puerto (PUERIDXX), pero segun como lo haya
//dejado el Autocomx puede llegar como texto, numero, arreglo u objeto {id, label}
const codigoPuerto = (item) => {
  if (item === null || item === undefined) return "";
  if (typeof item !== "object") return String(item).trim();
  if (item.id !== null && item.id !== undefined) return String(item.id).trim();
  return "";
};

/**
 * Arma el texto CODIGO - NOMBRE de los puertos guardados en un metadato. Si el
 * codigo no esta en la lista (puerto inactivo o la lista no cargo) se deja el
 * codigo solo, que es lo que se mostraba antes.
 * @param {*} valor - valor del metadato en JSONMETX
 * @param {object} nombresPorCodigo - { PUERIDXX: PUEDESCX }
 * @returns {string}
 */
export const describirPuerto = (valor, nombresPorCodigo = {}) => {
  const crudos = Array.isArray(valor) ? valor : [valor];
  return crudos
    .map((item) => {
      const codigo = codigoPuerto(item);
      if (codigo === "") return "";
      return nombresPorCodigo[codigo] ? `${codigo} - ${nombresPorCodigo[codigo]}` : codigo;
    })
    .filter(Boolean)
    .join(", ");
};
